import stage1 from "./01";
import stage2 from "./02";
import stage3 from "./03";
import stage4 from "./04";
import stage5 from "./05";
import stage6 from "./06";

const Stages = [stage1, stage2, stage3, stage4, stage5, stage6];
export default Stages;
